import CloseIcon, { ICloseIconProps } from 'Components/close-icon'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import React from 'react'

export const CloseIconForPublisher = ({ onClick }: ICloseIconProps) => {
  return (
    <CloseIcon
      onClick={() => {
        onClick()
        sendTeaCommEvent('click__publish_article_window_close')
      }}
    />
  )
}
